import React from 'react';

export const AddressCard = ({ children }) => (
  <div className='border bg-white w-full cursor-pointer p-4 rounded-md'>
    {children}
  </div>
);
